import { motion } from "framer-motion";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-36"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section label */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-sm tracking-[0.2em] uppercase mb-16"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 500,
            color: "var(--gold-dark)",
          }}
        >
          About Us
        </motion.p>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-0">
          {/* Left: Pull quote */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="md:col-span-5 flex items-start"
          >
            <blockquote
              className="text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.2] tracking-tight"
              style={{
                fontFamily: "var(--font-serif)",
                fontWeight: 400,
                color: "var(--text-primary)",
              }}
            >
              &ldquo;We identify what the market hasn&rsquo;t yet priced.
              <span style={{ color: "var(--gold-dark)" }}> Then we act.</span>
              &rdquo;
            </blockquote>
          </motion.div>

          {/* Gold vertical divider */}
          <div className="hidden md:flex md:col-span-1 justify-center">
            <div className="gold-divider-vertical" />
          </div>

          {/* Horizontal divider mobile */}
          <div className="md:hidden flex justify-start my-4">
            <div className="gold-rule" style={{ width: "60px" }} />
          </div>

          {/* Right: Paragraphs */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="md:col-span-6 flex flex-col gap-6"
          >
            <p
              className="text-base leading-relaxed"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "rgba(26, 26, 26, 0.8)",
              }}
            >
              Valtor Capital is a privately held property advisory and
              development management firm based in Sydney, Australia.
            </p>
            <p
              className="text-base leading-relaxed"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "rgba(26, 26, 26, 0.8)",
              }}
            >
              We work with a select group of sophisticated investors and
              developers to identify, structure, and deliver premium real estate
              opportunities.
            </p>
            <p
              className="text-base leading-relaxed"
              style={{
                fontFamily: "var(--font-sans)",
                fontWeight: 300,
                color: "rgba(26, 26, 26, 0.8)",
              }}
            >
              Our approach is disciplined, relationship-driven, and focused on
              long-term value creation — not volume.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
